import { USE_DEV_API } from '../config'

export const getPath = (path) =>
	USE_DEV_API ? `https://dev-api.gtobase.com/v2/${path}` : `https://api.gtobase.com/v2/${path}`
	// log data
	// USE_DEV_API ? `http://38.181.24.17:8080/v2/${path}` : `http://38.181.24.17:8080/v2/${path}`

export const redirectTo = (document, path) => {
	document.location = path
}

export const getRefreshHeader = () => {
	const user = JSON.parse(localStorage.getItem('user'))
	if (user && user.refresh_token) {
		return {
			Authorization: `Bearer ${user.refresh_token}`,
			Accept: 'application/json',
			'Content-Type': 'application/json',
		}
	}

	return {}
}

export const getAuthHeader = () => {
	const user = JSON.parse(localStorage.getItem('user'))
	if (user && user.access_token) {
		return {
			Authorization: `Bearer ${user.access_token}`,
			Accept: 'application/json',
			'Content-Type': 'application/json',
		}
	}

	return {}
}

export function onAccessTokenFetched(access_token) {
	this.subscribers = this.subscribers.filter((callback) => callback(access_token))
}
